import { useContext } from "react";
import { PageNewState, ConfirmationWithCommentDialogContext } from ".";

export const useConfirmationWithCommentDialogState = () => {
  const { pageState, setPageState } = useContext(
    ConfirmationWithCommentDialogContext,
  );
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
